<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M8.75149 17.6484c-.22496-.225-.35134-.5302-.35134-.8484 0-.3182.12638-.6234.35134-.8484L12.7031 12 8.75149 8.04839c-.21859-.22632-.33954-.52944-.33681-.84408.00274-.31463.12894-.61561.35143-.8381.22249-.22249.52346-.34869.8381-.35142.31464-.00274.61779.11822.84409.3368l4.8 4.80001c.225.225.3513.5302.3513.8484 0 .3182-.1263.6234-.3513.8484l-4.8 4.8c-.225.225-.53021.3513-.84841.3513-.3182 0-.62337-.1263-.8484-.3513Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M8.29289 4.29289c.39053-.39052 1.02369-.39052 1.41422 0l6.99999 7.00001c.3905.3905.3905 1.0237 0 1.4142l-6.99999 7c-.39053.3905-1.02369.3905-1.41422 0-.39052-.3905-.39052-1.0237 0-1.4142L14.5858 12 8.29289 5.70711c-.39052-.39053-.39052-1.02369 0-1.41422Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
